import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { ItemStoreEvents } from "../itemStore.store";

export const sceneGroupStoreHooks: Partial<ItemStoreEvents<SceneNodeItem<"group">>> = {
  async beforeCreate(item) {
    // Initialize data if not present
    if (!item.data) {
      item.data = {
        title: "",
        open: true
      };
    }

    // Apply group data defaults
    item.data.title = item.data.title ?? "";
    item.data.open = item.data.open ?? true;

    return item;
  }
};
